var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../utils/mobx/decorators/memoize';
export class ConfigTrait {
    get scaleProperties() {
        return Object.keys(this.scaleDefaultConfig);
    }
    scaleDefaultConfig = {
        width: 'width',
        minWidth: 'width',
        maxWidth: 'width',
        height: 'height',
        minHeight: 'height',
        maxHeight: 'height',
        left: 'width',
        right: 'width',
        top: 'height',
        bottom: 'height',
        translateX: 'width',
        translateY: 'height',
        fontSize: 'ratio',
        imageWidth: 'ratio',
        imageHeight: 'ratio',
        borderWidth: 'ratio',
        outlineWidth: 'ratio',
        borderRadius: 'ratio',
        textShadowH: 'ratio',
        textShadowV: 'ratio',
        textShadowBlurRadius: 'ratio',
        margin: 'ratio',
        marginBottom: 'height',
        marginTop: 'height',
        marginLeft: 'width',
        marginRight: 'width',
        padding: 'ratio',
        paddingBottom: 'height',
        paddingTop: 'height',
        paddingLeft: 'width',
        paddingRight: 'width',
        letterSpacing: 'ratio',
        draggableDefaultX: 'width',
        draggableDefaultY: 'height',
        draggableX: 'width',
        draggableY: 'height',
        textGrowMax: 'ratio',
        textGrowMin: 'ratio',
        columnWidth: 'width',
        columnGap: 'ratio',
        initialFontSize: 'ratio',
        expectedWidth: 'width',
        expectedHeight: 'height',
        expectedTop: 'height',
        expectedLeft: 'width',
    };
}
__decorate([
    memoize
], ConfigTrait.prototype, "scaleProperties", null);
export const configTrait = new ConfigTrait();
